import React, { Component } from 'react';

import './styles.scss';

export default class VerticalAlign extends Component {


    render() {
        return (
            <div className={'vertical-align-container'}>
                <div className={'vertical-align-content'}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/verticalAlign/VerticalAlign.js